import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../../images/cnt-widgets/privacy--disk.png'
import _imports_1 from '../../../../../images/cnt-widgets/privacy--paper-plane.png'
import _imports_2 from '../../../../../images/cnt-widgets/privacy--download.png'
import _imports_3 from '../../../../../images/cnt-widgets/privacy--eye.png'
import _imports_4 from '../../../../../images/cnt-widgets/privacy--mail.png'


const _withScopeId = n => (_pushScopeId("data-v-67866a99"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__cnt-table_privacy" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  valign: "middle",
  class: "privacy-table__descriptive"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "privacy-table__descriptive-wrapper" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
    /*#__PURE__*/_createTextVNode(" Datenarten ")
  ])
], -1))
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "privacy-table__descriptive" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "privacy-table__descriptive-wrapper" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
    /*#__PURE__*/_createTextVNode(" Weitergabe von Daten ")
  ])
], -1))
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "privacy-table__descriptive" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "privacy-table__descriptive-wrapper" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
    /*#__PURE__*/_createTextVNode(" Cloudnutzung ")
  ])
], -1))
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "privacy-table__descriptive" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "privacy-table__descriptive-wrapper" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }),
    /*#__PURE__*/_createTextVNode(" Tracking ")
  ])
], -1))
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "privacy-table__descriptive" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "privacy-table__descriptive-wrapper" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }),
    /*#__PURE__*/_createTextVNode(" Werbung ")
  ])
], -1))
const _hoisted_12 = ["innerHTML"]

import { cntProps } from 'vue/applications/frontend/mixins/cnt-component';
 
  
export default /*#__PURE__*/_defineComponent({
  __name: 'cnt-table_privacy',
  props: {...cntProps()},
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.contentItem)
      ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
          _createElementVNode("tr", null, [
            _hoisted_3,
            _createElementVNode("td", null, [
              _createElementVNode("div", {
                innerHTML: _ctx.contentItem.widget_data.data_types
              }, null, 8, _hoisted_4)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_5,
            _createElementVNode("td", null, [
              _createElementVNode("div", {
                innerHTML: _ctx.contentItem.widget_data.data_circulation
              }, null, 8, _hoisted_6)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_7,
            _createElementVNode("td", null, [
              _createElementVNode("div", {
                innerHTML: _ctx.contentItem.widget_data.cloud_usage
              }, null, 8, _hoisted_8)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_9,
            _createElementVNode("td", null, [
              _createElementVNode("div", {
                innerHTML: _ctx.contentItem.widget_data.tracking
              }, null, 8, _hoisted_10)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_11,
            _createElementVNode("td", null, [
              _createElementVNode("div", {
                innerHTML: _ctx.contentItem.widget_data.advertisments
              }, null, 8, _hoisted_12)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})